import { render, staticRenderFns } from "./sendUserEmail.vue?vue&type=template&id=543a3baf&"
import script from "./sendUserEmail.vue?vue&type=script&lang=js&"
export * from "./sendUserEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports